module.exports = __webpack_public_path__ + "quiz_and_mock_exam.svg?97acca93d13bc8b370a62cb33469cc2f";


//////////////////
// WEBPACK FOOTER
// ./static/quiz_and_mock_exam.svg
// module id = 40
// module chunks = 0